

export enum ProcessingServiceStatusEnum {
    CreateTaskTag = 1,
    TransferInvoice = 2,
    WaitingPayment = 3,
    Activation = 4,
    Complete = 5,
    Cancel = 6
}

export enum StepActivationServiceStatusEnum {
    Unknown = 1,
    Confirm = 2,
    CreateTaskTag = 3,
    TransferInvoice = 4,
    WaitingPayment = 5,
    Activation = 6,
    Complete = 7,
    Cancel = 8
}


export enum ServiceGroupEnum {
    Unknown = 1,
    Mobile = 2
}


export interface ProcessingServiceOption {
    redirectUrl: string | null,
    payOrderUrl: string | null
}

export interface ClientProcessingService {
    processingServiceId: string;
    clientPersonalAccountId: string;
    serviceId: string | null;
    serviceName: string | null;
    status: ProcessingServiceStatusEnum;
    group: ServiceGroupEnum;
    option: ProcessingServiceOption | null
}


export interface MobileServiceDiscount {
    discount: number;
    discountCategory: string | null;
    monthCount: number;
    requirements: string|null;


}

export interface MobileService {
    serviceId: string;
    serviceName: string;
    serviceFullName: string;
    periodical: boolean;
    tarif: number;
    isDiscount: boolean;
    fullTarif: number;
    discount: number|null;
    discountCategory: string|null;
    requirements: string|null;
    discounts: MobileServiceDiscount[];
}

export interface SelectMobileService {
    serviceId: string;
    serviceName: string;
    serviceFullName: string | null;
    tarif: number;
    amount: number;
    discount: MobileServiceDiscount;
}

export interface CreateTaskTagMobileServiceRequest {
    personalAccountId: string;
    serviceId: string;
    serviceName: string;
    serviceFullName: string | null;
    tarif: number;
    discount: number;
    monthCount: number;
    isSubscription: boolean;
    emailNotification: string | null;
    offerAdopted: boolean;
}

export interface ResultCreateTaskTagMobileService {
    taskTagId: string | null;
    taskTagSerialNumber: number | null;
    processingServiceId: string | null;
}

export interface MobileServiceCardVm {
    serviceId: string;
    serviceName: string;
    serviceFullName: string;
    tarif: number;
    isDiscount: boolean;
    fullTarif: number;
    discount: number|null;
    discountCategory: string|null;
    requirements: string|null;
    monthCount: number;

}



